<template>
  <div v-if="loading">
    <Loader />
  </div>
  <div v-else>
    <div class="margin-top modern-grid">
      <div class="cell">
        <strong>Balance</strong>
        <Format type="money" :currency="data.currency" :value="data.balance" />
      </div>
      <div class="cell">
        <strong>Expiration</strong>
        <template v-if="data.expires_at">
          <Format type="date" :value="data.expires_at" />
        </template>
        <template v-else>Expired</template>
      </div>
    </div>

    <div
      class="margin-top">
      <h2>History</h2>
      <div
        class="small-margin-bottom flex"
        v-for="row in data.history">
        <div
          style="width: 150px;">
          <Format type="date" :time="true" :value="row.date" />
        </div>
        <div
          style="width: 120px;">
          <Format type="money" :currency="data.currency" :value="row.amount" />
        </div>
        <div>
          {{ text(row) }}
          <OrderLink
            v-if="row.order_id"
            :id="row.order_id" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";

  export default {
    props: {
      id: {

      }
    },
    data: () => ({
      loading: false
    }),
    methods: {
      load () {
        Vue.api.get('/customer/' + this.id + '/wallet', {}, {
          before: () => this.loading = true,
          always: () => this.loading = false,
          callback: (data) => this.handleResponse(data)
        })
      },
      handleResponse (data) {
        this.data = data
      },
      text (row) {
        switch (row.trigger) {
          case 'migration':
            return 'Migrated from old loyalty system'
          case 'order_paid':
            return 'Earned bonus from'
          case 'products_returned':
            return 'Products returned on'
          case 'used_for_discount':
            return 'Used for payment on'
          case 'expired':
            return 'Balance on wallet expired'
          default:
            return row.trigger
        }
      }
    },
    created() {
      this.load()
    }
  }
</script>
